import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';

import amplitude from './amplitude';

const trackShopPageScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.SHOP_SECTION_VIEWED);
};

const trackQuickOrderBannerClick = () => {
    amplitude.trackWithPageId(amplitudeEventNames.QUICK_ORDER_BANNER_CLICKED);
};

const trackQuickOrderButtonClick = () => {
    amplitude.trackWithPageId(amplitudeEventNames.QUICK_ORDER_BUTTON_CLICKED);
};

const trackYourDeviceButtonClick = (buttonType, modelName) => {
    if (!buttonType || !modelName) return;

    amplitude.trackWithPageId(amplitudeEventNames.YOUR_DEVICES_BUTTON_CLICKED, {
        [analyticsEventProperties.BUTTON_TYPE]: buttonType,
        [analyticsEventProperties.IQOS_PRODUCT_MODEL_TYPE]: modelName,
    });
};

const trackShopByProductBannerClick = (trackingValue) => {
    if (!trackingValue) return;

    amplitude.trackWithPageId(amplitudeEventNames.SHOP_BY_PRODUCT_CLICKED, {
        [analyticsEventProperties.TRACKING_VALUE]: trackingValue,
    });
};

export default {
    trackShopPageScreen,
    trackQuickOrderBannerClick,
    trackQuickOrderButtonClick,
    trackYourDeviceButtonClick,
    trackShopByProductBannerClick,
};
